<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useSettings } from "~/store/settings";
import { isMobile } from "~/utils/constants";

const settings = useSettings();
const { azMenu } = storeToRefs(settings);
import t from "~/utils/translate";
import AToZInner from "~/components/layout/AToZMenu/AToZInner.vue";
import { ISport } from "~/types/sports/sport";

interface AZSport extends ISport {
	displayName: string;
	sportLink: string;
	sportIcon: string;
}

defineProps<{ sortedSports: { [key: string]: AZSport[] } }>();

const route = useRoute();
const router = useRouter();
watchEffect(() => {
	if (route.query["a-z-sports"] && isMobile) {
		azMenu.value = true;
	}
});
</script>

<template>
	<UiModal
		:title="t('a-to-z-sports')"
		:active="azMenu"
		@set-active="
			() => {
				azMenu = false;
				router.push({ query: {} });
			}
		"
		size="small"
		rootClass="z-[100] text-xs leading-4"
		v-if="azMenu && isMobile"
	>
		<template #titleElement>
			<span class="px-2">{{ t("a-to-z-sports") }}</span>
		</template>
		<AToZInner :sortedSports="sortedSports" />
	</UiModal>
</template>

<style scoped lang="scss"></style>
